





































import { groupBy } from 'lodash';
import moment from 'moment';
import { EvtEvent, EvtType } from 'gl-ms-events';
import { PosVehicleState } from 'gl-ms-positions';
import event from '@/components/fleet/realtime/components/event.vue';
import { ACTION_SET_DIALOG_TITLE } from '@/store/modules/generic';
import singleMenu from '@/components/fleet/realtime/components/singleMenu.vue';
import { decodeDispo } from '@/helpers';
import Pin from '../components/pin.vue';

const TEXT_MAP:any = {
    [PosVehicleState.IN_MOVEMENT_WITH_TRIP]: 'In movimento',
    [PosVehicleState.STUCK_WITH_TRIP]: 'Fermo',
    [PosVehicleState.IN_WARNING_WITH_TRIP]: 'Warning',
    [PosVehicleState.IN_ERROR_WITH_TRIP]: 'Alert',
    [PosVehicleState.NO_TRIP_ASSIGNED]: 'Senza viaggio',
};

const PROPERTIES_TO_SHOW: string[] = [
    'description',
    'fuel_type',
    'id_vehicle',
    'type',
    'active',
    'plate',
];

export default {
    data() {
        return {
            groups: [
                ['LOA', 'LOS', 'LOC'],
                ['UNA', 'UNS', 'UNC'],
            ],
        };
    },

    computed: {
        idTrip(this: any) {
            return (this.route && this.route.route) ? this.route.route.id_trip : '';
        },
        currentDispo(this: any) {
            return decodeDispo(this.idTrip);
        },
        editLink(this: any) {
            return `/fleet/planning?idTrip=${this.idTrip}`;
        },
        currentPlate(this: any) {
            return this.$store.getters.currentPlate;
        },
        hasRoute(this: any) {
            return this.route && this.route.currentEvents;
        },

        isLoading(this: any) {
            return this.$store.getters.isLoadingRoutes;
        },

        route(this: any) {
            return this.$store.state.realtime.selectedRoute;
        },
        isAutomatic(this: any) {
            const { route } = this.route;
            if (route.expected_route) {
                return false;
            }

            if (route.automatic_route) {
                return true;
            }

            return false;
        },
        state(this: any) {
            return this.$store.state.realtime.selectedRoute.state;
        },

        stateText(this: any) {
            return TEXT_MAP[this.state] || this.$t('fleetRealtimeRoute.notRecognized');
        },

        events(this: any) {
            const eventsId = Object.keys(this.$store.state.realtime.selectedRoute.currentEvents);
            if (Array.isArray(eventsId) && eventsId) {
                return this.$store.state.realtime.selectedRoute.currentEvents[eventsId[0]];
            }

            return 0;
        },
        groupedEvents(this: any) {
            const result: any = [];
            const filtered = this.events.filter((item: EvtEvent) => !['TST', 'DDR'].includes((item.event_type as EvtType).name));
            const clonedEvents = [...filtered];

            while (clonedEvents.length) {
                const currentEvent = clonedEvents[0];
                const belongGroup = this.groups.find((group: string[]) => group.includes((currentEvent.event_type as EvtType).name));
                if (belongGroup) {
                    const items: any = [];
                    belongGroup.forEach((item: string) => {
                        const found = clonedEvents.findIndex((cEvent: any) => (cEvent.event_type as EvtType).name.toLowerCase() === item.toLowerCase());
                        if (found >= 0) {
                            items.push(clonedEvents[found]);
                            clonedEvents.splice(found, 1);
                        }
                    });
                    if (items.length) {
                        result.push(items);
                    }
                } else {
                    result.push([clonedEvents[0]]);
                    clonedEvents.splice(0, 1);
                }
            }

            return result;
        },
    },
    watch: {
        currentDispo(this: any) {
            this.updateTitle();
        },

    },
    components: {
        singleMenu,
        event,
        Pin,
    },
    methods: {
        updateTitle(this: any) {
            let title = this.$t('fleetRealtime.tripDetail');
            if (this.currentDispo) {
                title = `Dispo: ${this.currentDispo}`;
            }

            this.$store.commit(ACTION_SET_DIALOG_TITLE, title);
        },
    },
    mounted(this: any) {
        this.updateTitle();
    },
};
